import React from 'react';
import { useSearchParams, Link } from 'react-router-dom';
import { XCircle, ArrowRight } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function BookingCancel() {
  const [searchParams] = useSearchParams();
  const bookingId = searchParams.get('booking_id');

  return (
    <div className="min-h-screen bg-slate-50 flex items-center justify-center px-4">
      <div className="max-w-lg w-full">
        <div className="bg-white rounded-2xl shadow-lg p-8 text-center animate-fade-in" data-testid="booking-cancel-page">
          <div className="w-20 h-20 bg-red-100 rounded-full flex items-center justify-center mx-auto mb-6">
            <XCircle className="w-12 h-12 text-red-500" />
          </div>
          
          <h1 className="text-2xl font-bold text-slate-900 mb-3 font-['Outfit']">
            Payment Cancelled
          </h1>
          
          <p className="text-slate-600 mb-8">
            Your payment was cancelled. Don't worry - no charges have been made.
            You can try booking again whenever you're ready.
          </p>
          
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/booking">
              <Button className="bg-[#38B6FF] hover:bg-blue-500 text-white px-8 w-full sm:w-auto" data-testid="try-again-btn">
                Try Again
                <ArrowRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
            <Link to="/">
              <Button variant="outline" className="px-8 w-full sm:w-auto" data-testid="back-home-btn">
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
}
